import './App.css';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import ProtectedRoute from './Components/ProtectedRoute';
import AuthProvider from './Contexts/AuthContext/AuthProvider.context';

import LoginPage from './Pages/LoginPage';
import RegisterPage from './Pages/RegisterPage';
//import DashboardPage from './Pages/DashboardPage';
import Layout from './Components/Common/Layout';
import FilterContextProvider from './Contexts/FilterContext/FilterContextProvider';
import UsersManagement from './Pages/UsersManagement';
import { ModalProvider } from './Contexts/Modal/Modal.context';
import { QueryClient, QueryClientProvider } from 'react-query';
import { InvoiceComparison } from './Components/Invoice/InvoiceComparison';
import FileAutomation from './Pages/FileAutomation';
import InventoryBuild from './Components/Inventory/InventoryBuild';
import InventoryComparison from './Components/Inventory/InventoryComparison';
import StockComparison from './Components/Inventory/StockComparison';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <FilterContextProvider>
            <Router>
              <Routes>
                  <Route element={<Layout/>}>
                    {/* <Route path='/dashboard' element={
                      <ProtectedRoute>
                        <DashboardPage />
                      </ProtectedRoute>
                    }/> */}
                    <Route path='/register' element={
                      <ProtectedRoute>
                        <RegisterPage />
                      </ProtectedRoute>
                    }/>
                    <Route path='/automations' element={
                      <ProtectedRoute>
                        <FileAutomation />
                      </ProtectedRoute>
                    }/>
                    <Route path='/automations/invoicecomparison' element={
                      <ProtectedRoute>
                        <InvoiceComparison />
                      </ProtectedRoute>
                    }/>
                    <Route path='/automations/inventorycomparison' element={
                      <ProtectedRoute>
                        <InventoryComparison/>
                      </ProtectedRoute>
                    }/>
                    <Route path='/automations/stockcomparison' element={
                      <ProtectedRoute>
                        <StockComparison/>
                      </ProtectedRoute>
                    }/>
                    <Route path='/automations/inventorybuild' element={
                      <ProtectedRoute>
                        <InventoryBuild />
                      </ProtectedRoute>
                    }/>
                    <Route path='/users' element={
                      <ProtectedRoute>
                        <ModalProvider>
                          <UsersManagement />
                        </ModalProvider>
                      </ProtectedRoute>
                    }/>
                  </Route>
                  <Route path='/' element={<LoginPage />} />
                  <Route path='/login' element={<LoginPage />} />
                </Routes>
            </Router>
          </FilterContextProvider>
        </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
